
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/datenschutzinformation",
      function () {
        return require("private-next-pages/de/datenschutzinformation.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/datenschutzinformation"])
      });
    }
  